$(document).ready(function() {
    const updateViews = (term) => {
        $.ajax({
            type: 'GET',
            url: '/glossary_terms/autocomplete?q='+term
        });
        term = term.replace(/[^\w]/g, '-');
        window.history.replaceState(null, null, "#" + term);
        $('html,body').scrollTop($('.nav-glossary')[0].offsetTop);
        $('.glossary .scrollbox').scrollTop(
            $(`#${term}.accordion-header`)[0].offsetTop
            - $('.glossary .scrollbox')[0].offsetTop
        );
        openCollapse("#" + term);
    };

    const openCollapse = (hash) => {
        let $slugHash = $(hash).find('.accordion-header button'),
            $termHash = $(`${hash}.accordion-header button`);
        if ($slugHash && $slugHash.hasClass('collapsed')) {
            $slugHash.click();
        }
        if ($termHash && $termHash.hasClass('collapsed')) {
            $termHash.click();
        }
    }

    if (window.location.hash) {
        openCollapse(window.location.hash);
    }

    $('.glossary #search-business .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: 1,
        classNames: {
            menu: 'menu',
            dataset: 'dataset',
            suggestion: 'suggestion',
        },
    }, {
        name: 'glossary',
        source: (query, syncResults) => {
            let terms = SaleHoo.GlossaryTerms || [],
                regex = new RegExp(query, 'i'),
                matches = [];
            $.each(terms, (i, term) => {
                if (regex.test(term)) {
                    matches.push(term);
                }
            });
            syncResults(matches);
        }
    }).on('typeahead:select', (e, term) => {
        updateViews(term);
    }).on('typeahead:autocomplete', (e, term) => {
        updateViews(term);
    });

    $('.accordion-item .collapse').on('show.bs.collapse', (e) => {
        $(e.target).closest('.accordion-item').find('.short-desc').hide();
    }).on('hide.bs.collapse', (e) => {
        $(e.target).closest('.accordion-item').find('.short-desc').show();
    });

    $('.nav-glossary a').on('click', (e) => {
        setTimeout(() => {
            if ($(window).width() > 992) {
                $('html,body').scrollTop(
                    + $('.glossary-hero').outerHeight()
                    + $('.nav-glossary').outerHeight()
                    + $('.navbar-desktop').outerHeight()
                    - 20 // extra padding
                );
            } else {
                $('html,body').scrollTop(
                    +$('#search-business').outerHeight()
                    + $('.nav-glossary').outerHeight()
                    + $('.navbar-mobile').outerHeight()
                    + 30 // extra padding
                );
            }
        }, 50);
    });

    $('.glossary .sidebar a.btn-link').on('click', (e) => {
        e.preventDefault();
        let term = $(e.target).attr('href');
        window.history.replaceState(null, null, term);
        $('html,body').scrollTop($('.nav-glossary')[0].offsetTop);
        $('.glossary .scrollbox').scrollTop(
            $(term + '.accordion-header')[0].offsetTop
            - $('.glossary .scrollbox')[0].offsetTop
        );
        openCollapse(term);
    });
});
